import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlannerViewsStateService {
  private _breakpointObserver = inject(BreakpointObserver);
  public isEditRouteView: WritableSignal<boolean> = signal(false);
  public isBuyTicketsView: WritableSignal<boolean> = signal(false);
  
  constructor() {
    // Observe the resizing of the window and set the isEditRouteView signal accordingly
    this._breakpointObserver
      .observe(['(max-width: 834px)'])
      .subscribe(result => {
        if (!result.matches) {
          this.isEditRouteView.set(false);
          this.isBuyTicketsView.set(false);
        }
      });
  }
}
